import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import moment from 'moment';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function createNewData(column, value) {
  if (column.type === 'money') {
    if (value[`${column.field}`]) {
      return <StyledTableCell align="center">{Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(value[`${column.field}`])}</StyledTableCell>;
    }
    return ''
  }
  if (column.type === 'date') {
    return <StyledTableCell align="center">{moment.utc(new Date(value[`${column.field}`])).format('DD/MM/YYYY')}</StyledTableCell>;
  }

  if (column.type === 'timedate') {
    return <StyledTableCell align="center">{value[`${column.field}`] ? moment.utc(value[`${column.field}`]).format('DD/MM/YYYY HH:mm') : column.noData}</StyledTableCell>;
  }
  return <StyledTableCell align="center" sx={{maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis'}}>{value[`${column.field}`] ? value[`${column.field}`] : column.noData ? column.noData : 'Não informado'}</StyledTableCell>;
}

function CollapseRows(row, index, columns, actions) {
  const [open, setOpen] = React.useState(false);

  const { cpr_yield_histories } = row

  return (
    <>
      <StyledTableRow key={index}>
        {columns.map((column) =>
          createNewData(column, row)
        )}
        {actions &&
          <StyledTableCell align="center">
            {actions.map((action, index) => (
              <Button
                key={index}
                variant={action.type.variant}
                color={action.type.color}
                onClick={() => action.onclick(row)}
                disabled={action.isDisabled(row)}
              >
                {action.name}
              </Button>
            ))
            }

            <Button
              variant='text'
              color='info'
              onClick={() => setOpen(!open)}
              disabled={cpr_yield_histories >= 0}
            >
              Histórico
            </Button>
          </StyledTableCell>}

      </StyledTableRow>

      <StyledTableRow  style={{borderLeft: '1px solid grey[300]'}}>
        <StyledTableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={11} sx={{
          paddingRight: 0,
          paddingLeft: 8,
        }}>
          <Collapse in={open} timeout="auto" unmountOnExit sx={{marginTop: 2, marginBottom: 2}}>
            {/* <Box > */}
            <TableContainer component={Paper}>
            <Table>

              <TableHead >
                <TableRow>
                  {columns.slice(1).map((column, index) => ( 
                    <StyledTableCell key={index} align="center">{returnColumn(column)}</StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  [...cpr_yield_histories]
                  .reverse()
                  .map((item, index) => {

                    if(row.status === item.status) {
                      return
                    }

                    return(
                    <StyledTableRow key={index}>
                      {
                        columns.slice(1).map((column, index) => (
                          <StyledTableCell align="center">{createNewData(column, item)}</StyledTableCell>
                        ))
                      }
                    </StyledTableRow>
                  )})
                }
              </TableBody>
              </Table> </TableContainer>
            {/* </Box> */}
          </Collapse>
        </StyledTableCell>
      </StyledTableRow>
    </>
  )
}

function returnColumn(column) {
  return column.headerName
}

export default function CustomizedTablesCollapse({ data, columns, actions }) {

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            {columns.map((column, index) => (
              <StyledTableCell key={index} align="center">{returnColumn(column)}</StyledTableCell>
            ))}
            {actions && <StyledTableCell align="center" >Ações</StyledTableCell>}

          </TableRow>
        </TableHead>
        <TableBody>
          {data
            .sort((function (b, a) { return b.current_installment - a.current_installment }))
            .map((row, index) => (
              CollapseRows(row, index, columns, actions)

          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}